<template>
  <div
    class="mb-6 md:mb-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-y-6 md:gap-y-10 gap-x-4 md:gap-x-8"
  >
    <slot />
  </div>
</template>
